webpackJsonp([204126604967074],{

/***/ 1803:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Highlight","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"label","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"length","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"start","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":"A datum highlight","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-highlight-4cc6336da63b2214fe12.js